import { PlayerParticipationAction, PlayerParticipationActionTypes, PlayerParticipationState } from '../types';
const initialState : PlayerParticipationState ={};

export const playerParticipationData = (state = initialState, action: PlayerParticipationActionTypes ) => {
    switch (action.type) {
      case PlayerParticipationAction.SET_PLAYER_PARTICIPATION:
        return {
          ...state,
          [action.gameId]: action.playerParticipationData,
        };
      default:
        return state;
    }
  };